module.exports = __webpack_public_path__ + "static/media/iv_save_taxes.e32d2ceb.svg";